module.exports = __webpack_public_path__ + "img/bissell.805a4da.png";